import React, { useEffect, useState } from "react";
import TauriBreadCrumbDropdown from "../TauriBreadcrumbDropdown";

const TauriIdentifierDropdown = ({ AccessRange, AccessCodes, AccessLevel, handleSelected }) => {
    const ACCESS_TYPE_MAP = {
        agent: { type: "agent", value: 1 },
        district: { type: "district", value: 2 },
        distributor: { type: "distributor", value: 3 },
        regions: { type: "region", value: 4 },
        executive: { type: "executive", value: 5 }
    };

    const accessLevels = [
        { level: 2, codeKey: 'DistrictManagerCode' },
        { level: 1, codeKey: 'AgentCode' },
        { level: 4, codeKey: 'RegionCode' },
        { level: 3, codeKey: 'DistributorCode' },
        { level: 5, codeKey: 'National' },
        { level: 0, codeKey: 'TerritoryCode' },
        { level: 0, codeKey: 'CustomerGroup' },
        { level: 8, codeKey: 'CustomerCode' },
        { level: 9, codeKey: 'ItemGroupCode' },
        { level: 10, codeKey: 'ItemCode' }
    ];

    let accessDetails = [];
    let codeName = '';

    const userAccessLevel = AccessLevel || -1;
    const accessLevelDetail = accessLevels?.find(item => item?.level === userAccessLevel);

    accessDetails = AccessCodes || [];
    codeName = accessLevelDetail?.codeKey;

    let emp = AccessRange?.split(',') || [];
    const concatenatedList = emp.flatMap(accessItem =>
        (AccessCodes || []).map(code => `${accessItem}|${code}`)
    );

    const initialCode = AccessCodes?.length > 0 ? AccessCodes[0]?.trim() : '';
    const [selectedCode, setSelectedCode] = useState(initialCode);

    const handleSelection = (selectedItem) => {
        const selectedItems = selectedItem ? selectedItem.split(",") : [];
        const isAllSelected = selectedItem === "ALL";

        let empAccess = AccessRange?.split(',') || [];
        const concatenatedEmp = empAccess.flatMap(accessItem =>
            (selectedItems || []).map(code => `${accessItem}|${code}`)
        );

        const selectedValue = isAllSelected
            ? (AccessLevel === ACCESS_TYPE_MAP.agent.value ? concatenatedList : AccessCodes).toString()
            : (AccessLevel === ACCESS_TYPE_MAP.agent.value ? concatenatedEmp : selectedItem).toString();

        setSelectedCode(
            selectedItem === ""
                ? "--Select--"
                : isAllSelected
                    ? "ALL"
                    : selectedItems.length > 1
                        ? "MULTIPLE"
                        : selectedItems
        );

        handleSelected(codeName, selectedValue);
    };

    useEffect(() => {

        const selectedValue =
            (AccessLevel === ACCESS_TYPE_MAP.agent.value ? concatenatedList.toString() : AccessCodes.toString());
        setSelectedCode("ALL");
        handleSelected(codeName, selectedValue);
    }, []);

    const identifierItems = [
        { label: 'ALL', value: 'ALL' },
        ...accessDetails.map((code, index) => ({
            label: code?.trim(),
            value: code?.trim()
        }))
    ];

    return (
        <TauriBreadCrumbDropdown
            items={identifierItems}
            onSelect={handleSelection}
            selectedItem={selectedCode || '--Select--'}
            className="code-filter mr-3"
            variant="secondary"
            id="codeDropdown"
            placeholder="--Select Code--"
            showCheckbox={true}
        />
    )
}

export default TauriIdentifierDropdown